import type { CampaignStatus, ReportType } from "~/types/services";
import serverUrls from "~/utils/serverUrls";

export const BASE_URL = serverUrls.baseUrl;
export const BASE_DOMAIN = serverUrls.baseDomain;

export const userTokenUrl = `${BASE_URL}/account/token/v1/`;
export const accessTokenUrl = `${serverUrls.sanjabAuth}/api/v3/token/access/`;
export const accountInfoUrl = `${serverUrls.sanjabAuth}/api/v1/user/`;
export const accountLogout = `${serverUrls.accounts}/logout/`;

export const planSubscriptionsUrl = `${BASE_URL}/subscription/v1/panel-subscriptions/`;
export const currentSubscriptionUrl = `${BASE_URL}/subscription/v1/current-paid-subscription/`;
export const paidSubscriptionUrl = `${BASE_URL}/subscription/v1/paid-subscriptions/`;
export const activateReferralSubscriptionUrl = `${BASE_URL}/subscription/v1/referral/`;
export const requestOrganizationSubscription = `${BASE_URL}/subscription/v1/organization-subscription-request/`;

export const pointHistoryUrl = `${BASE_URL}/subscription/v1/point-history-record/`;

export const pagesExploreUrl = `${BASE_URL}/explore/v1/pages/`;
export const simpleSearchUrl = `${BASE_URL}/explore/v1/simple-search/`;
export const bestInfluencersUrl = `${BASE_URL}/report/v1/best-influencers`;
export const filterExploreConfigUrl = `${BASE_URL}/explore/v1/config/filter`;
export const sortExploreConfigUrl = `${BASE_URL}/explore/v1/config/sorting`;
export const notReadyReportsUrl = `${BASE_URL}/report/v1/not-ready`;

export const transactionsUrl = `${BASE_URL}/payment/v1/payment-record/`;
export const checkDiscountUrl = `${BASE_URL}/payment/v1/check-discount/`;
export const submitPaymentUrl = `${BASE_URL}/payment/v1/online-payments/`;
export const purchaseSubscriptionUrl = `${BASE_URL}/payment/v1/subscription/purchase/`;

export const influencerListUrl = `${BASE_URL}/report/v1/influencer/`;
export const competitorListUrl = `${BASE_URL}/report/v1/competitor/`;
export const demoReportUrl = `${BASE_URL}/report/v1/demo-info`;

export const comparePreCheckUrl = `${BASE_URL}/report/v1/compare/pre-check/`;
export const compareUrl = `${BASE_URL}/report/v1/compare/`;
// TODO: think if there is a better way to handle this API URL
export const goftinoDataUrl = `${BASE_DOMAIN}/account/v1/goftino/`;

export const loginWithUserPass = `${serverUrls.sanjabAuth}/api/v1/auth/login/password`;
export const submitAuthPhoneNumber = `${serverUrls.sanjabAuth}/api/v1/auth/phone/`;
export const submitAuthOtp = `${serverUrls.sanjabAuth}/api/v1/auth/phone/verify`;
export const submitAuthInfo = `${serverUrls.sanjabAuth}/api/v1/auth/info`;
export const authLogout = `${serverUrls.sanjabAuth}/api/v1/auth/logout`;

export const campaignCreateUrl = `${BASE_URL}/campaign/v1/create/`;

export const campaignListUrl = (status?: CampaignStatus) =>
  `${BASE_URL}/campaign/v1/all?${status ? `status=${status}` : ""}`;
export const campaignDeleteUrl = (id: string) =>
  `${BASE_URL}/campaign/v1/delete/${id}/`;
export const campaignAddInfluencerToCampaignUrl = (campaignId: string) =>
  `${BASE_URL}/campaign/v1/influencer/add/${campaignId}/`;
export const campaignUpdateSingleInfluencerInCampaignUrl = (
  campaignId: string,
  reportId: string
) => `${BASE_URL}/campaign/v1/influencer/${campaignId}/${reportId}/update/`;
export const campaignActivateCampaignUrl = (campaignId: string) =>
  `${BASE_URL}/campaign/v1/activate/${campaignId}/`;
export const campaignRemoveInfluencerFromCampaignUrl = (
  campaignId: string,
  reportId: string
) => `${BASE_URL}/campaign/v1/influencer/${campaignId}/${reportId}/remove`;
export const campaignBatchUpdateInfluencersInCampaignUrl = (
  campaignId: string
) => `${BASE_URL}/campaign/v1/influencer/replace/${campaignId}`;
export const campaignGetDetailUrl = (campaignId: string) =>
  `${BASE_URL}/campaign/v1/detail/${campaignId}/`;

export const activateInfluencerReportUrl = (mediaId: string) =>
  `${BASE_URL}/report/v1/influencer/${mediaId}/activate/`;
export const activateCompetitorReportUrl = (mediaId: string) =>
  `${BASE_URL}/report/v1/competitor/${mediaId}/activate/`;
export const updateInfluencerReportUrl = (id: string) =>
  `${BASE_URL}/report/v1/influencer/${id}/update/`;
export const updateCompetitorReportUrl = (id: string) =>
  `${BASE_URL}/report/v1/competitor/${id}/update/`;
export const briefUrl = (id: string) => `${BASE_URL}/report/v1/${id}/brief/`;

export const reportsStatusUrl = (mediaId: string) =>
  `${BASE_URL}/report/v1/${mediaId}/reports-status/`;
export const profileInfoReportUrl = (id: string, type: ReportType) =>
  `${BASE_URL}/report/v1/${type}/${id}/profile-info/`;
export const reportInfoUrl = (id: string, type: ReportType) =>
  `${BASE_URL}/report/v1/${type}/${id}`;
export const followerRateUrl = (id: string, type: ReportType) =>
  `${BASE_URL}/report/v1/${type}/${id}/follower-rate/`;
export const contentFrequencyUrl = (id: string, type: ReportType) =>
  `${BASE_URL}/report/v1/${type}/${id}/content-frequency/`;
export const similarPagesUrl = (id: string, type: ReportType) =>
  `${BASE_URL}/report/v1/${type}/${id}/similar-pages/`;
export const bestPostingTimeUrl = (id: string, type: ReportType) =>
  `${BASE_URL}/report/v1/${type}/${id}/best-posting-time/`;
export const engagementRateUrl = (id: string, type: ReportType) =>
  `${BASE_URL}/report/v1/${type}/${id}/engagement-rate/`;
export const mentionImpactUrl = (id: string) =>
  `${BASE_URL}/report/v1/competitor/${id}/mention-impact/`;
export const adEffectivenessUrl = (id: string) =>
  `${BASE_URL}/report/v1/influencer/${id}/ad-effectiveness/`;
